import { useEffect, useRef, useState } from "react";

import Actionbar from "src/components/common/actionbar/Authactionbar";
import LoadingOverlay from "src/components/common/form/LoadingOverlay";
import { Message } from "src/components/common/form/Message";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";

import useUiuxStore from "src/store/useUiuxStore";


import { useMouseContent } from "src/utils/mouse/mouseContent";

import { Content_PUR6010_R01 } from "./Content_PUR6010_R01";
import { Info_PUR6010_R01 } from "./Info_PUR6010_R01";
import { SearchSection_PUR6010_R01 } from "./SearchSection_PUR6010_R01";
import { usePUR6010_R01Store } from "./Store_PUR6010_R01";
import { Table_PUR6010_R01 } from "./Table_PUR6010_R01";
import { AgGridReact } from "ag-grid-react";
import { PUR6010_R01DetailDto, PUR6010_R01Dto, PUR6010_R01HeaderDto } from "./Dto_PUR6010_R01";


export const Container_PUR6010_R01 = () => {

	const { 
		allCount,
		initData, 
		PUR6010_R01List,
		PUR6010_R01DetailList,
	} = usePUR6010_R01Store();

	
	const { moneyCdList, vatTypeList } = useCommonCodeStore();
	const { tabList, setMessage } = useUiuxStore();

	const RESIZER = {
		code: 'PUR6010_R01',
		type: 'height',
		storageKey: 'PUR6010_R01-split-height',
		min: 5,
		max: 80,
		default: 40
	} as const;
	const gridRef = useRef<AgGridReact<PUR6010_R01HeaderDto>>(null);
	const detailGridRef = useRef<AgGridReact<PUR6010_R01DetailDto>>(null);

	const containerRef = useRef<HTMLDivElement>(null);
	const infoRef = useRef<HTMLDivElement>(null);
	const isResizing = useRef(false);

	

	const { 
		splitValue,
		handleMouseDown,
		handleMouseUp
	} = useMouseContent({
		resizer: RESIZER,
		isResizing,
		containerRef,
		infoRef
	});

	const {
		handleExcelClick,
		fetchData,
		defaultPUR6010_R01HeaderRow,
		defaultPUR6010_R01DetailRow,
		initContainerData,
		handleDeleteClick,
		handleCreateClick,
		handleSaveClick,
	} = Content_PUR6010_R01({
		gridRef,
		detailGridRef,
		tabList, setMessage,
		containerRef,
		isResizing,		
	});

	useEffect(() => { handleCreateClick(); }, []);

	return <div className={`content-container`}>
		
		<Actionbar
			onFetchClick={fetchData}
			onCreateClick={handleCreateClick}
			onDeleteClick={handleDeleteClick}
			onSaveClick={handleSaveClick}
			onExcelClick={handleExcelClick}
			onInitClick={initContainerData}
		/>
		<SearchSection_PUR6010_R01 />

		<div className="flex-1 flex flex-col p-[12px] gap-[4px] min-h-0"
			ref={containerRef}>
			<div className="w-full" style={{ height: `${splitValue}%` }} ref={infoRef}>
				<Info_PUR6010_R01
					defaultPUR6010_R01HeaderRow={defaultPUR6010_R01HeaderRow()}
				/>
			</div>
			<div
				className="h-[6px] bg-gray-100 cursor-row-resize hover:bg-gray-300"
				onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => handleMouseDown('UD', e.nativeEvent)}
				onDragStart={(e: React.DragEvent<HTMLDivElement>) => e.preventDefault()}
				data-comment="리사이저"
			/>
			<div className="w-full" style={{ height: `${100 - splitValue}%` }}>
				<Table_PUR6010_R01 gridRef={gridRef} defaultPUR6010_R01HeaderRow={defaultPUR6010_R01HeaderRow()} handleCreateClick={handleCreateClick} />
			</div>
		</div>
		<Message />
	</div>
}